// Polyfills
import '@babel/polyfill';
import objectFitImages from 'object-fit-images';

// Vendors
import 'intersection-observer';
import './vendor/modernizr-custom';

import 'jquery';
import 'popper.js';
import './vendor/bootstrap.min.js';


// CSS entry point
import '../scss/main.scss';

// Components
import './components/menu';
import './components/slider';
import './components/fancybox';
//import './components/backtop';


// Init object-fit polyfill
objectFitImages();

